import API from 'aurora-api';
import * as urls from 'aurora-api/urls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;

const api = new API(BASE_URL);

class WorkflowService {
  static fetchWorkflow = (id, stepKey) => api.get(urls.WORKFLOW.FETCH_WORKFLOW, id, { stepKey });

  static fetchWorkflowHistory = id => api.get(urls.WORKFLOW.FETCH_WORKFLOW_HISTORY, id);

  static fetchWorkflowHistoryV2 = id => api.get(urls.WORKFLOW.FETCH_WORKFLOW_HISTORY_V2, id);

  static registerApplication = data => api.post(urls.WORKFLOW.REGISTER_APPLICATION, data);

  static submitWorkflow = (data, url) => api.post(url, data);

  static uploadDocument = (body, params) => api.post(urls.DOCUMENT.UPLOAD_DOCUMENT, body, params);

  static uploadDocumentComplete = body => api.post(urls.DOCUMENT.DOCUMENT_COMPLETE, body);

  static fetchDocuments = data => api.get(urls.DOCUMENT.FETCH_DOCUMENTS, null, data);

  static downloadDocuments = data => api.get(urls.DOCUMENT.DOWNLOAD_DOCUMENT, null, data);

  static fetchPaymentReceipt = id => api.get(urls.PAYMENT.FETCH_PAYMENT_RECEIPT, id);

  static checkValidation = data => api.post(urls.WORKFLOW.VALIDATE, data);

  static fetchApplication = (id, param = null) => api.get(urls.WORKFLOW.REGISTER_APPLICATION, id, param);

  static fetchApplicationDetails = id => api.get(`${urls.CERTIFICATES.FETCH_APPLICATION_DETAILS}/${id}`);

  static cancelApplication = (id, params = { status: 'DISCARD' }) =>
    api.post(urls.WORKFLOW.CANCEL_APPLICATION, null, params, id);

  static checkPostValidation = data => api.post(urls.WORKFLOW.POST_VALIDATE, data);

  static fetchApplicationTypes = () => api.get(urls.WORKFLOW.FETCH_APPLICATION_TYPES);

  static updateFeedback = data => api.post(urls.WORKFLOW.UPDATE_HAPPYNESS_METER_FEEDBACK, data);

  static checkEtisalatLead = data => api.post(urls.WORKFLOW.ETISALAT_LEAD, data);
}

export default WorkflowService;
